"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BranchDto = _interopRequireDefault(require("../model/BranchDto"));
var _BranchEntityDto = _interopRequireDefault(require("../model/BranchEntityDto"));
var _BranchGetResponseEntity = _interopRequireDefault(require("../model/BranchGetResponseEntity"));
var _HospitalDto = _interopRequireDefault(require("../model/HospitalDto"));
var _HospitalEntityDto = _interopRequireDefault(require("../model/HospitalEntityDto"));
var _HospitalLocationDto = _interopRequireDefault(require("../model/HospitalLocationDto"));
var _HospitalLocationEntityDto = _interopRequireDefault(require("../model/HospitalLocationEntityDto"));
var _HospitalUpdateDto = _interopRequireDefault(require("../model/HospitalUpdateDto"));
var _ScanFacilityDto = _interopRequireDefault(require("../model/ScanFacilityDto"));
var _ScanFacilityEntityDto = _interopRequireDefault(require("../model/ScanFacilityEntityDto"));
var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));
var _UserDto = _interopRequireDefault(require("../model/UserDto"));
var _UserEntityDto = _interopRequireDefault(require("../model/UserEntityDto"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * Branch User Hospital Service
                                                                                                                                                                                                                                                                                                                                                                                               * Branch User Hospital Service - API version 2
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * The version of the OpenAPI document: 2
                                                                                                                                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                               * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                               * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               */
/**
* Branch service.
* @module 2/BranchApi
* @version 6.2.7
*/
var BranchApi = /*#__PURE__*/function () {
  /**
  * Constructs a new BranchApi. 
  * @alias module:2/BranchApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function BranchApi(apiClient) {
    _classCallCheck(this, BranchApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Deletes the specified branch user association. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
   * @param {String} branchId The branch identifier.
   * @param {String} userId The user identifier.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
   */
  _createClass(BranchApi, [{
    key: "branchesBranchIdUsersUserIdDeleteWithHttpInfo",
    value: function branchesBranchIdUsersUserIdDeleteWithHttpInfo(branchId, userId) {
      var postBody = null;
      // verify the required parameter 'branchId' is set
      if (branchId === undefined || branchId === null) {
        throw new Error("Missing the required parameter 'branchId' when calling branchesBranchIdUsersUserIdDelete");
      }
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling branchesBranchIdUsersUserIdDelete");
      }
      var pathParams = {
        'branchId': branchId,
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/{branchId}/users/{userId}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified branch user association. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} branchId The branch identifier.
     * @param {String} userId The user identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesBranchIdUsersUserIdDelete",
    value: function branchesBranchIdUsersUserIdDelete(branchId, userId) {
      return this.branchesBranchIdUsersUserIdDeleteWithHttpInfo(branchId, userId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the list of available branch's complete information. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BranchGetResponseEntity>} and HTTP response
     */
  }, {
    key: "branchesGetWithHttpInfo",
    value: function branchesGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_BranchGetResponseEntity["default"]];
      return this.apiClient.callApi('/branches', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the list of available branch's complete information. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BranchGetResponseEntity>}
     */
  }, {
    key: "branchesGet",
    value: function branchesGet() {
      return this.branchesGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Deletes the specified hospital and all its locations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The hospital identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
     */
  }, {
    key: "branchesHospitalsIdDeleteWithHttpInfo",
    value: function branchesHospitalsIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesHospitalsIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/hospitals/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified hospital and all its locations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The hospital identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesHospitalsIdDelete",
    value: function branchesHospitalsIdDelete(id) {
      return this.branchesHospitalsIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Adds a new hospital location to the specified hospital and related branch. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The hospital identifier.
     * @param {module:model/HospitalLocationDto} hospitalLocationDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HospitalLocationEntityDto} and HTTP response
     */
  }, {
    key: "branchesHospitalsIdLocationsPostWithHttpInfo",
    value: function branchesHospitalsIdLocationsPostWithHttpInfo(id, hospitalLocationDto) {
      var postBody = hospitalLocationDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesHospitalsIdLocationsPost");
      }
      // verify the required parameter 'hospitalLocationDto' is set
      if (hospitalLocationDto === undefined || hospitalLocationDto === null) {
        throw new Error("Missing the required parameter 'hospitalLocationDto' when calling branchesHospitalsIdLocationsPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HospitalLocationEntityDto["default"];
      return this.apiClient.callApi('/branches/hospitals/{id}/locations', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Adds a new hospital location to the specified hospital and related branch. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The hospital identifier.
     * @param {module:model/HospitalLocationDto} hospitalLocationDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HospitalLocationEntityDto}
     */
  }, {
    key: "branchesHospitalsIdLocationsPost",
    value: function branchesHospitalsIdLocationsPost(id, hospitalLocationDto) {
      return this.branchesHospitalsIdLocationsPostWithHttpInfo(id, hospitalLocationDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Updates the hospital Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The hospital identifier.
     * @param {module:model/HospitalUpdateDto} hospitalUpdateDto The hospital information to update.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HospitalEntityDto} and HTTP response
     */
  }, {
    key: "branchesHospitalsIdPutWithHttpInfo",
    value: function branchesHospitalsIdPutWithHttpInfo(id, hospitalUpdateDto) {
      var postBody = hospitalUpdateDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesHospitalsIdPut");
      }
      // verify the required parameter 'hospitalUpdateDto' is set
      if (hospitalUpdateDto === undefined || hospitalUpdateDto === null) {
        throw new Error("Missing the required parameter 'hospitalUpdateDto' when calling branchesHospitalsIdPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HospitalEntityDto["default"];
      return this.apiClient.callApi('/branches/hospitals/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Updates the hospital Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The hospital identifier.
     * @param {module:model/HospitalUpdateDto} hospitalUpdateDto The hospital information to update.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HospitalEntityDto}
     */
  }, {
    key: "branchesHospitalsIdPut",
    value: function branchesHospitalsIdPut(id, hospitalUpdateDto) {
      return this.branchesHospitalsIdPutWithHttpInfo(id, hospitalUpdateDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Deletes the specified hospital location. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The hospital location identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
     */
  }, {
    key: "branchesHospitalsLocationsIdDeleteWithHttpInfo",
    value: function branchesHospitalsLocationsIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesHospitalsLocationsIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/hospitals/locations/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified hospital location. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The hospital location identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesHospitalsLocationsIdDelete",
    value: function branchesHospitalsLocationsIdDelete(id) {
      return this.branchesHospitalsLocationsIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Updates the hospital location Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The hospital location identifier.
     * @param {module:model/HospitalLocationDto} hospitalLocationDto The hospital location information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HospitalLocationEntityDto} and HTTP response
     */
  }, {
    key: "branchesHospitalsLocationsIdPutWithHttpInfo",
    value: function branchesHospitalsLocationsIdPutWithHttpInfo(id, hospitalLocationDto) {
      var postBody = hospitalLocationDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesHospitalsLocationsIdPut");
      }
      // verify the required parameter 'hospitalLocationDto' is set
      if (hospitalLocationDto === undefined || hospitalLocationDto === null) {
        throw new Error("Missing the required parameter 'hospitalLocationDto' when calling branchesHospitalsLocationsIdPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HospitalLocationEntityDto["default"];
      return this.apiClient.callApi('/branches/hospitals/locations/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Updates the hospital location Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The hospital location identifier.
     * @param {module:model/HospitalLocationDto} hospitalLocationDto The hospital location information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HospitalLocationEntityDto}
     */
  }, {
    key: "branchesHospitalsLocationsIdPut",
    value: function branchesHospitalsLocationsIdPut(id, hospitalLocationDto) {
      return this.branchesHospitalsLocationsIdPutWithHttpInfo(id, hospitalLocationDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Deletes the specified branch and all its associations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
     */
  }, {
    key: "branchesIdDeleteWithHttpInfo",
    value: function branchesIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified branch and all its associations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesIdDelete",
    value: function branchesIdDelete(id) {
      return this.branchesIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets single specified branch information. (Requires: Roles -> RH.BUH.Read, RH.BUH.L, RH.BUH.R, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BranchEntityDto} and HTTP response
     */
  }, {
    key: "branchesIdGetWithHttpInfo",
    value: function branchesIdGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _BranchEntityDto["default"];
      return this.apiClient.callApi('/branches/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets single specified branch information. (Requires: Roles -> RH.BUH.Read, RH.BUH.L, RH.BUH.R, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BranchEntityDto}
     */
  }, {
    key: "branchesIdGet",
    value: function branchesIdGet(id) {
      return this.branchesIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the list of hospitals specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/HospitalEntityDto>} and HTTP response
     */
  }, {
    key: "branchesIdHospitalsGetWithHttpInfo",
    value: function branchesIdHospitalsGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdHospitalsGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_HospitalEntityDto["default"]];
      return this.apiClient.callApi('/branches/{id}/hospitals', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the list of hospitals specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/HospitalEntityDto>}
     */
  }, {
    key: "branchesIdHospitalsGet",
    value: function branchesIdHospitalsGet(id) {
      return this.branchesIdHospitalsGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the list of hospital locations for specified branch and hospital. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {String} hospitalId The hospital identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/HospitalLocationEntityDto>} and HTTP response
     */
  }, {
    key: "branchesIdHospitalsHospitalIdLocationsGetWithHttpInfo",
    value: function branchesIdHospitalsHospitalIdLocationsGetWithHttpInfo(id, hospitalId) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdHospitalsHospitalIdLocationsGet");
      }
      // verify the required parameter 'hospitalId' is set
      if (hospitalId === undefined || hospitalId === null) {
        throw new Error("Missing the required parameter 'hospitalId' when calling branchesIdHospitalsHospitalIdLocationsGet");
      }
      var pathParams = {
        'id': id,
        'hospitalId': hospitalId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_HospitalLocationEntityDto["default"]];
      return this.apiClient.callApi('/branches/{id}/hospitals/{hospitalId}/locations', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the list of hospital locations for specified branch and hospital. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {String} hospitalId The hospital identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/HospitalLocationEntityDto>}
     */
  }, {
    key: "branchesIdHospitalsHospitalIdLocationsGet",
    value: function branchesIdHospitalsHospitalIdLocationsGet(id, hospitalId) {
      return this.branchesIdHospitalsHospitalIdLocationsGetWithHttpInfo(id, hospitalId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Adds a new hospital and assigns to the specified branch. Single location is mandatory. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {module:model/HospitalDto} hospitalDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/HospitalEntityDto} and HTTP response
     */
  }, {
    key: "branchesIdHospitalsPostWithHttpInfo",
    value: function branchesIdHospitalsPostWithHttpInfo(id, hospitalDto) {
      var postBody = hospitalDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdHospitalsPost");
      }
      // verify the required parameter 'hospitalDto' is set
      if (hospitalDto === undefined || hospitalDto === null) {
        throw new Error("Missing the required parameter 'hospitalDto' when calling branchesIdHospitalsPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HospitalEntityDto["default"];
      return this.apiClient.callApi('/branches/{id}/hospitals', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Adds a new hospital and assigns to the specified branch. Single location is mandatory. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {module:model/HospitalDto} hospitalDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/HospitalEntityDto}
     */
  }, {
    key: "branchesIdHospitalsPost",
    value: function branchesIdHospitalsPost(id, hospitalDto) {
      return this.branchesIdHospitalsPostWithHttpInfo(id, hospitalDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Updates the branch Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {Object} opts Optional parameters
     * @param {module:model/BranchDto} opts.branchDto The branch information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BranchEntityDto} and HTTP response
     */
  }, {
    key: "branchesIdPutWithHttpInfo",
    value: function branchesIdPutWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['branchDto'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _BranchEntityDto["default"];
      return this.apiClient.callApi('/branches/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Updates the branch Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {Object} opts Optional parameters
     * @param {module:model/BranchDto} opts.branchDto The branch information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BranchEntityDto}
     */
  }, {
    key: "branchesIdPut",
    value: function branchesIdPut(id, opts) {
      return this.branchesIdPutWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the scan facility list for the specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ScanFacilityEntityDto>} and HTTP response
     */
  }, {
    key: "branchesIdScanfacilitiesGetWithHttpInfo",
    value: function branchesIdScanfacilitiesGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdScanfacilitiesGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_ScanFacilityEntityDto["default"]];
      return this.apiClient.callApi('/branches/{id}/scanfacilities', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the scan facility list for the specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ScanFacilityEntityDto>}
     */
  }, {
    key: "branchesIdScanfacilitiesGet",
    value: function branchesIdScanfacilitiesGet(id) {
      return this.branchesIdScanfacilitiesGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Adds the scan facility Information. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch id.
     * @param {module:model/ScanFacilityDto} scanFacilityDto The scan facility information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ScanFacilityEntityDto} and HTTP response
     */
  }, {
    key: "branchesIdScanfacilitiesPostWithHttpInfo",
    value: function branchesIdScanfacilitiesPostWithHttpInfo(id, scanFacilityDto) {
      var postBody = scanFacilityDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdScanfacilitiesPost");
      }
      // verify the required parameter 'scanFacilityDto' is set
      if (scanFacilityDto === undefined || scanFacilityDto === null) {
        throw new Error("Missing the required parameter 'scanFacilityDto' when calling branchesIdScanfacilitiesPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ScanFacilityEntityDto["default"];
      return this.apiClient.callApi('/branches/{id}/scanfacilities', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Adds the scan facility Information. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch id.
     * @param {module:model/ScanFacilityDto} scanFacilityDto The scan facility information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ScanFacilityEntityDto}
     */
  }, {
    key: "branchesIdScanfacilitiesPost",
    value: function branchesIdScanfacilitiesPost(id, scanFacilityDto) {
      return this.branchesIdScanfacilitiesPostWithHttpInfo(id, scanFacilityDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the list of surgeon specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UserEntityDto>} and HTTP response
     */
  }, {
    key: "branchesIdSurgeonsGetWithHttpInfo",
    value: function branchesIdSurgeonsGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdSurgeonsGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_UserEntityDto["default"]];
      return this.apiClient.callApi('/branches/{id}/surgeons', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the list of surgeon specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UserEntityDto>}
     */
  }, {
    key: "branchesIdSurgeonsGet",
    value: function branchesIdSurgeonsGet(id) {
      return this.branchesIdSurgeonsGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Adds a new surgeon to the specified branch. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {module:model/UserDto} userDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserEntityDto} and HTTP response
     */
  }, {
    key: "branchesIdSurgeonsPostWithHttpInfo",
    value: function branchesIdSurgeonsPostWithHttpInfo(id, userDto) {
      var postBody = userDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdSurgeonsPost");
      }
      // verify the required parameter 'userDto' is set
      if (userDto === undefined || userDto === null) {
        throw new Error("Missing the required parameter 'userDto' when calling branchesIdSurgeonsPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserEntityDto["default"];
      return this.apiClient.callApi('/branches/{id}/surgeons', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Adds a new surgeon to the specified branch. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {module:model/UserDto} userDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserEntityDto}
     */
  }, {
    key: "branchesIdSurgeonsPost",
    value: function branchesIdSurgeonsPost(id, userDto) {
      return this.branchesIdSurgeonsPostWithHttpInfo(id, userDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the list of users specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/UserEntityDto>} and HTTP response
     */
  }, {
    key: "branchesIdUsersGetWithHttpInfo",
    value: function branchesIdUsersGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdUsersGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_UserEntityDto["default"]];
      return this.apiClient.callApi('/branches/{id}/users', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the list of users specified branch. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/UserEntityDto>}
     */
  }, {
    key: "branchesIdUsersGet",
    value: function branchesIdUsersGet(id) {
      return this.branchesIdUsersGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Adds a new user and assigns him to the specified branch. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {module:model/UserDto} userDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserEntityDto} and HTTP response
     */
  }, {
    key: "branchesIdUsersPostWithHttpInfo",
    value: function branchesIdUsersPostWithHttpInfo(id, userDto) {
      var postBody = userDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesIdUsersPost");
      }
      // verify the required parameter 'userDto' is set
      if (userDto === undefined || userDto === null) {
        throw new Error("Missing the required parameter 'userDto' when calling branchesIdUsersPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserEntityDto["default"];
      return this.apiClient.callApi('/branches/{id}/users', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Adds a new user and assigns him to the specified branch. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {String} id The branch identifier.
     * @param {module:model/UserDto} userDto The user data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserEntityDto}
     */
  }, {
    key: "branchesIdUsersPost",
    value: function branchesIdUsersPost(id, userDto) {
      return this.branchesIdUsersPostWithHttpInfo(id, userDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Adds the branch Information. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {module:model/BranchDto} branchDto The branch information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BranchEntityDto} and HTTP response
     */
  }, {
    key: "branchesPostWithHttpInfo",
    value: function branchesPostWithHttpInfo(branchDto) {
      var postBody = branchDto;
      // verify the required parameter 'branchDto' is set
      if (branchDto === undefined || branchDto === null) {
        throw new Error("Missing the required parameter 'branchDto' when calling branchesPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _BranchEntityDto["default"];
      return this.apiClient.callApi('/branches', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Adds the branch Information. (Requires: Roles -> RH.BUH.Create, RH.BUH.C, RH.BUH.Admin).
     * @param {module:model/BranchDto} branchDto The branch information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BranchEntityDto}
     */
  }, {
    key: "branchesPost",
    value: function branchesPost(branchDto) {
      return this.branchesPostWithHttpInfo(branchDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of scan facilities that are linked to a user. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} userEmail The user email as identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ScanFacilityEntityDto>} and HTTP response
     */
  }, {
    key: "branchesScanfacilitiesGetWithHttpInfo",
    value: function branchesScanfacilitiesGetWithHttpInfo(userEmail) {
      var postBody = null;
      // verify the required parameter 'userEmail' is set
      if (userEmail === undefined || userEmail === null) {
        throw new Error("Missing the required parameter 'userEmail' when calling branchesScanfacilitiesGet");
      }
      var pathParams = {};
      var queryParams = {
        'userEmail': userEmail
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_ScanFacilityEntityDto["default"]];
      return this.apiClient.callApi('/branches/scanfacilities', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of scan facilities that are linked to a user. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} userEmail The user email as identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ScanFacilityEntityDto>}
     */
  }, {
    key: "branchesScanfacilitiesGet",
    value: function branchesScanfacilitiesGet(userEmail) {
      return this.branchesScanfacilitiesGetWithHttpInfo(userEmail).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Deletes the specified scan facility and all its user associations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The scan facility identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
     */
  }, {
    key: "branchesScanfacilitiesIdDeleteWithHttpInfo",
    value: function branchesScanfacilitiesIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesScanfacilitiesIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/scanfacilities/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified scan facility and all its user associations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The scan facility identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesScanfacilitiesIdDelete",
    value: function branchesScanfacilitiesIdDelete(id) {
      return this.branchesScanfacilitiesIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets single scan facility. (Requires: Roles -> RH.BUH.Read, RH.BUH.L, RH.BUH.R, RH.BUH.Admin).
     * @param {String} id The scan facility id.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ScanFacilityEntityDto} and HTTP response
     */
  }, {
    key: "branchesScanfacilitiesIdGetWithHttpInfo",
    value: function branchesScanfacilitiesIdGetWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesScanfacilitiesIdGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ScanFacilityEntityDto["default"];
      return this.apiClient.callApi('/branches/scanfacilities/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets single scan facility. (Requires: Roles -> RH.BUH.Read, RH.BUH.L, RH.BUH.R, RH.BUH.Admin).
     * @param {String} id The scan facility id.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ScanFacilityEntityDto}
     */
  }, {
    key: "branchesScanfacilitiesIdGet",
    value: function branchesScanfacilitiesIdGet(id) {
      return this.branchesScanfacilitiesIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Updates the specified scan facility. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The scan facility identifier.
     * @param {module:model/ScanFacilityDto} scanFacilityDto The scan facility data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ScanFacilityEntityDto} and HTTP response
     */
  }, {
    key: "branchesScanfacilitiesIdPutWithHttpInfo",
    value: function branchesScanfacilitiesIdPutWithHttpInfo(id, scanFacilityDto) {
      var postBody = scanFacilityDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesScanfacilitiesIdPut");
      }
      // verify the required parameter 'scanFacilityDto' is set
      if (scanFacilityDto === undefined || scanFacilityDto === null) {
        throw new Error("Missing the required parameter 'scanFacilityDto' when calling branchesScanfacilitiesIdPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ScanFacilityEntityDto["default"];
      return this.apiClient.callApi('/branches/scanfacilities/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Updates the specified scan facility. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The scan facility identifier.
     * @param {module:model/ScanFacilityDto} scanFacilityDto The scan facility data exchange object.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ScanFacilityEntityDto}
     */
  }, {
    key: "branchesScanfacilitiesIdPut",
    value: function branchesScanfacilitiesIdPut(id, scanFacilityDto) {
      return this.branchesScanfacilitiesIdPutWithHttpInfo(id, scanFacilityDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Deletes the specified surgeon. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The surgeon identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
     */
  }, {
    key: "branchesSurgeonsIdDeleteWithHttpInfo",
    value: function branchesSurgeonsIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesSurgeonsIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/surgeons/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified surgeon. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The surgeon identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesSurgeonsIdDelete",
    value: function branchesSurgeonsIdDelete(id) {
      return this.branchesSurgeonsIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Updates the surgeon Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The surgeon identifier.
     * @param {module:model/UserDto} userDto The surgeon information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserEntityDto} and HTTP response
     */
  }, {
    key: "branchesSurgeonsIdPutWithHttpInfo",
    value: function branchesSurgeonsIdPutWithHttpInfo(id, userDto) {
      var postBody = userDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesSurgeonsIdPut");
      }
      // verify the required parameter 'userDto' is set
      if (userDto === undefined || userDto === null) {
        throw new Error("Missing the required parameter 'userDto' when calling branchesSurgeonsIdPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserEntityDto["default"];
      return this.apiClient.callApi('/branches/surgeons/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Updates the surgeon Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The surgeon identifier.
     * @param {module:model/UserDto} userDto The surgeon information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserEntityDto}
     */
  }, {
    key: "branchesSurgeonsIdPut",
    value: function branchesSurgeonsIdPut(id, userDto) {
      return this.branchesSurgeonsIdPutWithHttpInfo(id, userDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a single user by email address and list associated branches. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} userEmail The user email as identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserEntityDto} and HTTP response
     */
  }, {
    key: "branchesUsersGetWithHttpInfo",
    value: function branchesUsersGetWithHttpInfo(userEmail) {
      var postBody = null;
      // verify the required parameter 'userEmail' is set
      if (userEmail === undefined || userEmail === null) {
        throw new Error("Missing the required parameter 'userEmail' when calling branchesUsersGet");
      }
      var pathParams = {};
      var queryParams = {
        'userEmail': userEmail
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UserEntityDto["default"];
      return this.apiClient.callApi('/branches/users', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a single user by email address and list associated branches. (Requires: Roles -> RH.BUH.ReadList, RH.BUH.L, RH.BUH.Admin).
     * @param {String} userEmail The user email as identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserEntityDto}
     */
  }, {
    key: "branchesUsersGet",
    value: function branchesUsersGet(userEmail) {
      return this.branchesUsersGetWithHttpInfo(userEmail).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Deletes the specified user and all its associations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The user identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StatusMessageDto} and HTTP response
     */
  }, {
    key: "branchesUsersIdDeleteWithHttpInfo",
    value: function branchesUsersIdDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesUsersIdDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StatusMessageDto["default"];
      return this.apiClient.callApi('/branches/users/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Deletes the specified user and all its associations. (Requires: Roles -> RH.BUH.Delete, RH.BUH.D, RH.BUH.Admin).
     * @param {String} id The user identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StatusMessageDto}
     */
  }, {
    key: "branchesUsersIdDelete",
    value: function branchesUsersIdDelete(id) {
      return this.branchesUsersIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Updates the user Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The user identifier.
     * @param {module:model/UserDto} userDto The user information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserEntityDto} and HTTP response
     */
  }, {
    key: "branchesUsersIdPutWithHttpInfo",
    value: function branchesUsersIdPutWithHttpInfo(id, userDto) {
      var postBody = userDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling branchesUsersIdPut");
      }
      // verify the required parameter 'userDto' is set
      if (userDto === undefined || userDto === null) {
        throw new Error("Missing the required parameter 'userDto' when calling branchesUsersIdPut");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _UserEntityDto["default"];
      return this.apiClient.callApi('/branches/users/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Updates the user Information. (Requires: Roles -> RH.BUH.Update, RH.BUH.U, RH.BUH.Admin).
     * @param {String} id The user identifier.
     * @param {module:model/UserDto} userDto The user information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserEntityDto}
     */
  }, {
    key: "branchesUsersIdPut",
    value: function branchesUsersIdPut(id, userDto) {
      return this.branchesUsersIdPutWithHttpInfo(id, userDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return BranchApi;
}();
exports["default"] = BranchApi;